import { render, staticRenderFns } from "./ClosingButton.vue?vue&type=template&id=6eca30fa&scoped=true&"
import script from "./ClosingButton.vue?vue&type=script&lang=js&"
export * from "./ClosingButton.vue?vue&type=script&lang=js&"
import style0 from "./ClosingButton.vue?vue&type=style&index=0&id=6eca30fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eca30fa",
  null
  
)

export default component.exports